import type { PostViewingRecordFailReason, PostViewingRecordStatus } from 'viewup-api/v2';
import { PostCampaignStatus } from '../types';

const statusMap: Record<
  Exclude<PostViewingRecordStatus, 'finished'>,
  PostCampaignStatus | undefined
> = {
  applied: PostCampaignStatus.APPLY_SUCCESS,
  confirmed: PostCampaignStatus.EARNING_SUCCESS,
  failed: undefined,
  submitted: PostCampaignStatus.SUBMITTED,
} as const;

const failReasonMap: Record<
  Exclude<PostViewingRecordFailReason, 'penalty' | 'suspension'>,
  PostCampaignStatus
> = {
  rejected: PostCampaignStatus.REJECT,
  unmaintained: PostCampaignStatus.DEVIATION,
  unsubmitted: PostCampaignStatus.NOT_SUBMITTED,
} as const;

export const serverStatusMapToClientStatus = (
  status: PostViewingRecordStatus,
  failReason?: PostViewingRecordFailReason | null,
): PostCampaignStatus => {
  if (status === 'failed' && failReason) {
    return failReasonMap[failReason];
  }

  return statusMap[status];
};

export const clientStatusMapToServerStatus = (status: PostCampaignStatus) => {
  if (status === PostCampaignStatus.APPLY_SUCCESS) return 'applied';
  if (status === PostCampaignStatus.SUBMITTED) return 'submitted';
  if (status === PostCampaignStatus.EARNING_SUCCESS) return 'confirmed';
  return 'failed';
};
